wbApp.controller('FormsCtrl', ['$scope', '$q', '$modal', '$translate', 'formSvc', 'securitySvc', 'tenantSettingSvc',
function ($scope, $q, $modal, $translate, formSvc, securitySvc, tenantSettingSvc) {

    $scope.tenantSetting = tenantSettingSvc.settings;
    
    function refreshData()
    {
        return $q(function (resolve, reject) {
            let all = formSvc.getAll();
            all.then(function (data) {
                $scope.forms = data;
                setSelectedForm(null);
                resolve();
            }, function (error) {
                $scope.forms = [];
                setSelectedForm(null);
                reject();
            });
        });
            
    }

    refreshData();

    $scope.$on('refreshData', function (e, data) {
        refreshData();
    });

    $scope.gridSettings = {
        name: 'forms',
        columns: [
            { dataField: 'id', caption: $translate.instant('TXT_LBL_ID'), dataType: 'string', visible: false },
            { dataField: 'name', caption: $translate.instant('TXT_LBL_NAME'), dataType: 'string', sortOrder: 'asc' },
            { dataField: 'isActive', caption: $translate.instant('TXT_LBL_ACTIVE'), dataType: 'boolean', width: '60px' },
            {
                dataField: 'formType',
                caption: $translate.instant('TXT_LBL_FORM_TYPE'),
                dataType: 'string',
                lookup: {
                    allowClearing: true,
                    dataSource: {
                        store: {
                            type: 'array',
                            data: [
                                { id: 0, name: $translate.instant('TXT_FROM_TYPE_GENERIC') },
                                { id: 1, name: $translate.instant('TXT_FROM_TYPE_KINDERGARTEN_ENROLLMENT') }
                            ],
                            key: "id"
                        },
                        pageSize: 10,
                        paginate: false
                    },
                    valueExpr: 'id', 
                    displayExpr: 'name'
                },
                width: '140px',
                visible: $scope.tenantSetting.enableKindergartenSupport
            },
            {dataField: 'auditEvent.eventTimeUtc', caption: $translate.instant('TXT_LBL_UPDATED_AT'), dataType: 'date', format: { type: 'shortDateShortTime' }, width: '120px' },
            { dataField: 'auditEvent.userFullName', caption: $translate.instant('TXT_LBL_UPDATED_BY'), dataType: 'string', width: '160px' },
            { dataField: 'displayOrder', caption: $translate.instant('TXT_ORDER'), dataType: 'number', width: '60px' },
            { dataField: 'auditEvent.revision', caption: $translate.instant('TXT_LBL_REVISION'), dataType: 'number', width: '60px' },
        ],
        customCommands: [{
            text: $translate.instant('TXT_SHOW_PREVIEW'),
            isVisible: function () { return securitySvc.isInRole('FormsDefinitions'); },
            callback: function (data) { $scope.onShowFormPreview(data.id); }
        }]
    }

    $scope.onShowFormPreview = function (formId) {
        formPreviewPromise.$promise.then(function () {
            formPreviewPromise.$scope.formId = formId;
            formPreviewPromise.$scope.enableSave = false;
            formPreviewPromise.show();
        });
    }

    $scope.onRowSelected = function (data) {
        setSelectedForm(data);
    }

    $scope.onRowAdd = function () {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = formSvc.createNew();
            detailDialogPromise.$scope.onFormSave = function (model) {
                refreshData();
            };
            detailDialogPromise.show();
        });
    }

    $scope.onRowEdit = function (data) {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = angular.copy(data);
            detailDialogPromise.$scope.onFormSave = function () {
                refreshData();
            };
            detailDialogPromise.show();
        });
    }

    $scope.onRowCopy = function (data) {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = angular.copy(data);
            detailDialogPromise.$scope.model.isNew = true;
            detailDialogPromise.$scope.model.id = null;
            detailDialogPromise.$scope.onFormSave = function (model) {
                refreshData().then(function() {
                    if (!!$scope.gridSettings && !!$scope.gridSettings.gridInstance) {
                        $timeout(function () {
                            $scope.gridSettings.gridInstance.selectRows([model.id], false).then(function (rows) {
                                if (!rows || !rows.length) {
                                    setSelectedForm(null);
                                }
                            });
                        }, 100);
                    }
                });
            };
            detailDialogPromise.show();
        });
    }

    $scope.onRowDelete = function (data) {
        formSvc.remove(data.id).$promise.then(function () {
            refreshData();
        });
    }

    function setSelectedForm(form, refresh) {
        $scope.selectedForm = form;
        $scope.$broadcast('formSelectionChanged', $scope.selectedForm);
    }

    $scope.tabs = [
    {
        title: 'TXT_LBL_FORM_RESPONSES',
        template: "form/form-detail-tabs/responses.html"
    }];

    $scope.tabs.activeTab = 0;

    var detailDialogPromise = $modal({
        templateUrl: 'forms/forms-detail.html',
        show: false,
        scope: $scope.$new()
    });

    var formPreviewPromise = $modal({
        templateUrl: 'forms/forms-response-preview.html',
        show: false,
        scope: $scope.$new()
    });

}]);
